import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const resolveScore = (score: number, maxScore: number) => {
  if (maxScore === 4) {
    switch (score) {
      case 1:
        return `${COLOR.VENETIAN_RED}`;
      case 2:
        return `${COLOR.YELLOW_ORANGE}`;
      case 3:
        return `${COLOR.EMERALD}`;
      case 4:
        return `${COLOR.GO_GREEN}`;
    }
  }

  switch (true) {
    case score >= 1 && score < 2:
      return `${COLOR.VENETIAN_RED}`;
    case score >= 2 && score < 3:
      return `${COLOR.BEGONIA}`;
    case score >= 3 && score < 4:
      return `${COLOR.TOPAZ}`;
    case score >= 4 && score < 5:
      return `${COLOR.YELLOW_ORANGE}`;
    case score >= 5 && score < 6:
      return `${COLOR.EMERALD}`;
    case score === 6:
      return `${COLOR.GO_GREEN}`;
  }

  return `${COLOR.LAVENDER_GRAY}`;
};

export const OuterScoreIndicator = styled.div`
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  background-color: ${COLOR.LAVENDER_GRAY};
  margin-left: 2px;
`;

export const InnerScoreIndicator = styled.div<{ width: string; score: number; maxScore: number }>`
  width: ${({ width }) => width};
  height: 100%;
  border-radius: ${({ width }) => (width !== '100%' ? '0.25rem 0 0 0.25rem' : 'inherit')};
  background-color: ${({ score, maxScore }) => resolveScore(score, maxScore)};
`;

export const ScoreContainer = styled.div`
  display: flex;
  gap: 2px;
  margin-top: 0.25rem;
  justify-content: space-between;
  align-items: center;
  > span {
    margin-right: 0.25rem;
  }
`;

export const ScoreIndicatorContainer = styled.div`
  display: flex;
`;
